import React, {PropTypes} from 'react';
import classNames from 'classnames';

const Panel = ({
  children,
  className,
  style,
  title
}) => (
  <div className={classNames(
      'panel',
      className
    )}
    style={style}>
    {title
      ? <div className="panel-heading">
          <h3 className="panel-title">{title}</h3>
        </div>
      : null
    }
    <div className="panel-body">
      {children}
    </div>
  </div>
);

Panel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.node
};

Panel.defaultProps = {
  className: 'panel-default',
  title: null,
  style: {}
};

export default Panel;



// WEBPACK FOOTER //
// ./src/features/shared/Panel.jsx